import React from "react";
import { Skeleton, SkeletonCircle } from "../components/Ui/Skeleton/Skeleton";

/**
 * Mirrors the public homepage's nav + hero shape while the initial auth
 * check is in flight, replacing the old "Small Potatoes Loading..." spinner.
 * Reuses the same sp-hero / sp-nav-links / sp-hamburger responsive classes
 * as LandingNav.js and Hero.js so it collapses to the mobile layout
 * (hamburger, single-column hero) exactly like the real page does.
 */
const AppLoadingSkeleton = () => (
  <div className="landing-page" style={{ background: "var(--color-bg)", minHeight: "100vh" }}>
    <header
      className="nav"
      style={{
        display: "flex",
        alignItems: "center",
        position: "sticky",
        top: 0,
        zIndex: 40,
        background: "var(--color-bg)",
        boxShadow: "var(--shadow-sm)",
        padding: "14px 32px",
      }}
    >
      <div style={{ display: "flex", alignItems: "center", gap: 10, marginRight: 40 }}>
        <SkeletonCircle size={26} />
        <Skeleton width={120} height={19} />
      </div>
      <div className="sp-nav-links" style={{ display: "flex", gap: 28, marginRight: "auto" }}>
        <Skeleton width={54} height={14} />
        <Skeleton width={54} height={14} />
        <Skeleton width={70} height={14} />
      </div>
      <div className="sp-nav-secondary" style={{ display: "flex", alignItems: "center", gap: 10 }}>
        <Skeleton width={110} height={38} radius={999} />
      </div>
      <div className="sp-hamburger" style={{ display: "none", marginLeft: "auto", minWidth: 44, minHeight: 44 }}>
        <Skeleton width={24} height={24} />
      </div>
    </header>

    <section
      className="sp-hero"
      style={{
        display: "grid",
        gridTemplateColumns: "1.05fr 0.95fr",
        gap: 56,
        alignItems: "center",
        maxWidth: 1240,
        margin: "0 auto",
        padding: "64px 32px 24px",
      }}
    >
      <div>
        <Skeleton width={110} height={24} radius={999} style={{ marginBottom: 18 }} />
        <Skeleton width="90%" height={44} style={{ marginBottom: 10 }} />
        <Skeleton width="70%" height={44} style={{ marginBottom: 18 }} />
        <Skeleton width="95%" height={17} style={{ marginBottom: 8 }} />
        <Skeleton width="60%" height={17} style={{ marginBottom: 22 }} />
        <div style={{ display: "flex", gap: 24, marginBottom: 22, flexWrap: "wrap" }}>
          <Skeleton width={90} height={14} />
          <Skeleton width={90} height={14} />
          <Skeleton width={90} height={14} />
        </div>
        <div style={{ display: "flex", gap: 14, flexWrap: "wrap" }}>
          <Skeleton width={150} height={46} radius={999} />
          <Skeleton width={150} height={46} radius={999} />
        </div>
      </div>
      <Skeleton className="sp-hero-photo" height={420} radius={24} />
    </section>
  </div>
);

export default AppLoadingSkeleton;
